import { getDate, getFormattedDateString } from '../../../../app/header/utils'
import { TableAlign, TableCell, TableRow } from '../../../components/Table'
import { formatNumber } from '../../../util'

interface PriceRowProps {
  /**
   * Price to show
   */
  lastClose: number | null

  /**
   * Date when the last price was valid to.
   *
   * @default current time
   */
  lastTime: number | null

  /**
   * Column span for the left column with date
   */
  leftSpan?: number

  /**
   * Column span for the right column, which is empty
   */
  rightSpan?: number

  priceAlign?: TableAlign

  /**
   * Show additional empty cells around lastClose cell
   */
  showAdditionalCells?: boolean
}

export function PriceRow({
  lastClose,
  lastTime,
  leftSpan,
  rightSpan,
  priceAlign = TableAlign.Center,
  showAdditionalCells = true,
}: PriceRowProps) {
  if (lastTime === null || lastClose === null) return null

  const date = getDate(lastTime * 1000)
  const formattedDate = getFormattedDateString(date, 'dateOnly')
  const formattedTime = getFormattedDateString(date, 'timeOnly')

  return (
    <TableRow>
      <TableCell colSpan={leftSpan} align={TableAlign.Right} className="h-6 text-gray-500 dark:text-gray-300">
        Price <span className="text-gray-100 dark:text-gray-700">•</span> {formattedDate}{' '}
        <span className="text-gray-100 dark:text-gray-700">•</span> {formattedTime} ET
      </TableCell>
      {showAdditionalCells && <td />}
      <TableCell align={priceAlign} className="font-medium">
        {formatNumber(lastClose)}
      </TableCell>
      {showAdditionalCells && <td />}
      <TableCell colSpan={rightSpan} />
    </TableRow>
  )
}
